<template id="mapPoiListTmpl">
	<div>

		<!-- TITLE -->
		<v-card-subtitle>
			{{$t('lbl.pois')}}
		</v-card-subtitle>
		
		<div v-if="poilist != null && poilist != []">
			<v-card-text v-for="item in poilist" v-bind:key="item.poi_id">
				<v-row v-if="item.things != null && item.things != [] && item.things[0] != null">
					<v-col cols="12" md="8">
						<v-icon class="inactiveIcon mr-2" v-if="item.flags == null || (item.flags !=null && item.flags.active != true)">visibility_off</v-icon>
						<v-icon class="alertIcon mr-2" v-if="item.alert" >mdi-alert</v-icon>
						<strong>{{item.things[0].thing_name}}</strong>
					</v-col>
					
					<v-col cols="12" md="4" class="text-left text-md-right">
						
						<v-tooltip top 
							v-if="isEmptyObj(item) == false && isEmptyObj(item.things) == false && isEmptyObj(item.things[0]) == false && isEmptyString(item.things[0].thing_link) == false">
							<template v-slot:activator="{ on, attrs }">
								<v-btn 
									class="button-secondary mr-2" fab small depressed
									v-bind="attrs"
									v-on="on"
									v-on:click="openPoiThingLink(item.things[0].thing_link)"
									><v-icon>list_alt</v-icon></v-btn>
							</template>
							<span>{{ $t('btn.poiThingLink')}}</span>
						</v-tooltip>

						<v-tooltip top> 
							<template v-slot:activator="{ on, attrs }">
								<v-btn 
									class="button-secondary mr-2" fab small depressed 
									v-bind="attrs"
									v-on="on"
									v-on:click="openPoiDetails(item.poi_id)"
									><v-icon>zoom_in</v-icon></v-btn>
							</template>
							<span>{{ $t('btn.poiThingCurrentValues')}}</span>
						</v-tooltip>
						
						<v-tooltip top> 
							<template v-slot:activator="{ on, attrs }">
								<v-btn 
									class="button-secondary mr-2" fab small depressed
									v-bind="attrs"
									v-on="on" 
									v-on:click="operPoiChartExternal(item.poi_id)"
									><v-icon>bar_chart</v-icon></v-btn>
							</template>
							<span>{{ $t('btn.poiThingStats')}}</span>
						</v-tooltip>
						
						<v-tooltip top> 
							<template v-slot:activator="{ on, attrs }">
								<v-btn 
									class="button-secondary mr-2" fab small depressed
									v-bind="attrs"
									v-on="on" 
									v-on:click="openEditPoiDialog(item)"
									><v-icon>create</v-icon></v-btn>
							</template>
							<span>{{ $t('btn.edit')}}</span>
						</v-tooltip>	
						
						<v-tooltip top> 
							<template v-slot:activator="{ on, attrs }">
								<v-btn 
									class="button-secondary mr-2" fab small depressed
									v-bind="attrs"
									v-on="on" 
									v-on:click="deletePoi(item.poi_id)"
									><v-icon>delete</v-icon></v-btn>
							</template>
							<span>{{ $t('btn.delete')}}</span>
						</v-tooltip>

					</v-col>
				</v-row>
				<v-divider></v-divider>		
			</v-card-text>
		</div>	
		<div v-else>{{$t('err.noPoiFound')}}</div>	

		<!-- EDIT POI -->
		<ct-poi-frm ref="dlgEditPoi" :orgid="orgid" :siteid="siteid" :mapitem="mapitem" :poiitem="poiObjMod"></ct-poi-frm>

		<!-- POI DETAILS -->
		<dlg-poi-details ref="dlgPoiDetails" :orgid="orgid" :siteid="siteid" :mapDetailObj="mapitem"></dlg-poi-details>	

		<!-- POI CHART EXTERNAL -->
		<dlg-thing-stats ref="dlgThingStatsExternal" :orgid="orgid" :siteid="siteid" :mapDetailObj="mapitem"></dlg-thing-stats>

	</div>		
</template>
<script>
import i18n from '@/i18n';
import {events} from '@/event-bus.js';
import constants from '@/ctConstants.js';

import ctPoiFrm from "@/components/appadmin/ctPoiFrm.vue";
import ctDialogPoiDetails from "@/components/commons/ctDialogPoiDetails.vue";
import ctDialogThingStats from "@/components/commons/ctDialogThingStats.vue";

export default {
	i18n,
    data: () => ({
		poiObjMod: null,
	}),
	props: ['orgid', 'siteid', 'mapitem','poilist'],
	components: {
		'ct-poi-frm': ctPoiFrm,
		'dlg-poi-details':ctDialogPoiDetails,
		"dlg-thing-stats":ctDialogThingStats
	},
	methods: {
		openAddPoiDialog()
		{
			if(!this.isEmptyObj(this.mapitem) && !this.isEmptyString(this.mapitem.sitemap_id))
			{
				
				//=== CREATE EMPTY POI WITH 1 THING
				this.poiObjMod = this.getEmptyPoiObj();
				
				this.$refs.dlgEditPoi.openEditPoiDialog();
			} 
			else 
			{
				this.$root.setDialogMsg(i18n.t('err.mapSelectedNotValid'));
			}
		},
		openEditPoiDialog(poiObj) 
		{
			if(!this.isEmptyObj(poiObj) && !this.isEmptyObj(poiObj.poi_id)) 
			{
				var endpoint2go = constants.ENDPOINT_GUI_ADMIN_ORGANIZATIONS + '/'+ this.orgid + '/sites/'+ this.siteid +'/maps/' + this.mapitem.sitemap_id +'/pois/'+poiObj.poi_id;
				this.$root.genericGetAuthenticatedCallEngine(endpoint2go, this.callbackOpenEditPoiDialog, 'err.loadingPoi');				
			} 
			else 
			{
				this.$root.setDialogMsg(i18n.t('err.poiSelectedNotValid'));
			}
		},
		callbackOpenEditPoiDialog(responseData)
		{
			if(!this.isEmptyObj(responseData))
			{
				this.poiObjMod =  this.getSecurePoiByAwsObj(responseData);
				this.$refs.dlgEditPoi.openEditPoiDialog();
			}
			else 
			{
				this.$root.setDialogMsg(i18n.t("err.loadingPoi"));
			}
		},	
		deletePoi(poiId)
		{
			if(this.isEmptyString(this.orgid))  
			{
				this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
			} 
			else if(this.isEmptyString(this.siteid))  
			{
				this.$root.setDialogMsg(i18n.t("err.siteSelectedNotValid"));
			}
			else if(this.isEmptyObj(this.mapitem) || (!this.isEmptyObj(this.mapitem) && this.isEmptyString(this.mapitem.sitemap_id)))  
			{
				this.$root.setDialogMsg(i18n.t('err.mapSelectedNotValid'));
			}
			else if(this.isEmptyString(poiId))
			{
				this.$root.setDialogMsg(i18n.t('err.poiSelectedNotValid'));
			}
			else{
				if(confirm("POI " + poiId + " - " + i18n.t('msg.confirmDelete')))
				{
					var endpoint2go = constants.ENDPOINT_GUI_ADMIN_ORGANIZATIONS;
					endpoint2go += '/'+ this.orgid;
					endpoint2go += '/sites/'+ this.siteid;
					endpoint2go += '/maps/' + this.mapitem.sitemap_id;
					endpoint2go += '/pois/' + poiId;
					
					this.$root.genericDeleteAuthenticatedCallEngine(endpoint2go, this.callbackDeletePoi, 'err.deletePoi') ;

				}
			}
		},
		callbackDeletePoi(responseData)
		{
			if(!this.isEmptyObj(responseData))
			{
				events.$emit('reloadPoiList');
			}
			else 
			{
				this.$root.setDialogMsg(i18n.t("err.deletePoi"));
			}
		},
		openPoiDetails(poiId)
		{
			if(this.isEmptyString(this.orgid))  
			{
				this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
			} 
			else if(this.isEmptyString(this.siteid))  
			{
				this.$root.setDialogMsg(i18n.t("err.siteSelectedNotValid"));
			}
			else if(this.isEmptyObj(this.mapitem) ||(!this.isEmptyObj(this.mapitem) && this.isEmptyString(this.mapitem.sitemap_id)))  
			{
				this.$root.setDialogMsg(i18n.t('err.mapSelectedNotValid'));
			}
			else if(this.isEmptyString(poiId))  
			{
				this.$root.setDialogMsg(i18n.t('err.poiSelectedNotValid'));
			}
			else 
			{
				// CHIAMATA AL DETTAGLIO
				var endpoint2go = constants.ENDPOINT_GATEWAY_POI_DETAILS;
				endpoint2go += "?org=" + this.orgid;
				endpoint2go += "&site=" + this.siteid;
				endpoint2go += "&map=" + this.mapitem.sitemap_id;
				endpoint2go += "&poi=" + poiId;
				this.$root.genericGetAuthenticatedCallEngine(endpoint2go, this.callbackOpenPoiDetails, 'err.loadingPoi');
			}
		},
		callbackOpenPoiDetails(responseData) 
		{
			if(!this.isEmptyObj(responseData))
			{
				this.$refs.dlgPoiDetails.openDlgPoiDetails(responseData);
			}
			else 
			{
				this.$root.setDialogMsg(i18n.t("err.loadingPoi"));
			}
		},
		operPoiChartExternal(poi_id)
        {
            this.$refs.dlgThingStatsExternal.openThingStats(poi_id);
        },
		openPoiThingLink(link)
        {
            window.open(link, '_blank');
        }, 
	}
}
</script>